module.exports = __webpack_public_path__ + "img/2010 winteressen 026.a6b2bf02.jpg";